export default __webpack_public_path__ + "static/media/logo.29592d4c.png";